export default __webpack_public_path__ + "static/media/mex.0f58bc53.svg";